module.exports = __webpack_public_path__ + "static/media/miguel.01ae2acc.jpg";